(function ($, window, undefined) {
	/*
	 * Carrega as fotos
	 */
	(function () {
		'use strict';

		$(window).load(function () {
			var li = $('.box-sobre-fotos [data-img]');

			li.each(function () {
				var current = $(this);
				current.css({
					'background-image': 'url(' + current.data('img') + ')'
				});
			});
		});
	}());



    // Contador de numeros com animacao
	var animateNumbers = true;


	function animateCountNumbers() {
	    $('.count').each(function () {
	        $(this).prop('Counter', 0).animate({
	            Counter: $(this).text()
	        }, {
	            duration: 2000,
	            //easing: 'swing',
	            step: function (now) {
	                $(this).text(Math.ceil(now));
	            }
	        });
	    });
	}

	$(window).on('scroll', function () {
	    var scrollY = $(window).scrollTop();

	    if (scrollY > 1450 && animateNumbers) {
	        animateNumbers = false;
	        animateCountNumbers();
	    }

	});





	/*
	 * Cria scroll horizontal para a linha do tempo.
	 * Esse scroll é ativado quando a tela for menor que o tamanho definido
	 */
	(function () {
		'use strict';

		$('.linha-tempo').mCustomScrollbar({
			axis: 'x',
			advanced: {
				autoExpandHorizontalScroll: true
			}
		});
	}());

	/*
	 * Quando um item da linha do tempo for clicada esse função será disparada.
	 * Essa função altera o estado ativo do item clicado e do item atualmente ativo.
	 */
	(function () {
		var linhaTempo = {
			itemAtivo: 0,
			linhaTempoElementoLi: $('.linha-tempo li'),
			linhaTempoElementoSuperior: $('.linha-tempo-info-superior'),
			linhaTempoElementoInferior: $('.linha-tempo-info-inferior'),
			linhaTempoElementoSuperiorLi: $('.linha-tempo-info-superior li'),
			linhaTempoElementoInferiorLi: $('.linha-tempo-info-inferior li')
		};

		linhaTempo.init = function () {
			linhaTempo.linhaTempoElementoLi.eq(linhaTempo.itemAtivo).addClass('ativo');

			linhaTempo.ShowInfo();
		};

		linhaTempo.setItemAtivo = function (index) {
			linhaTempo.itemAtivo = index;
			linhaTempo.linhaTempoElementoLi.removeClass('ativo');
			linhaTempo.linhaTempoElementoLi.eq(linhaTempo.itemAtivo).addClass('ativo');

			linhaTempo.ShowInfo();
		};

		linhaTempo.ShowInfo = function () {
			var heightElement = 0;

			linhaTempo.linhaTempoElementoSuperiorLi.animate({ opacity: 0 }, 300, function () {
				$(this).hide();
			});
			linhaTempo.linhaTempoElementoInferiorLi.animate({ opacity: 0 }, 300, function () {
				$(this).hide();
			});

			setTimeout(function () {
				linhaTempo.linhaTempoElementoSuperiorLi.eq(linhaTempo.itemAtivo).show();
				linhaTempo.linhaTempoElementoInferiorLi.eq(linhaTempo.itemAtivo).show();

				heightElement = linhaTempo.linhaTempoElementoSuperiorLi.eq(linhaTempo.itemAtivo).height();

				linhaTempo.linhaTempoElementoSuperior.animate({ height: heightElement }, 300, function () {
					linhaTempo.linhaTempoElementoSuperiorLi.eq(linhaTempo.itemAtivo).animate({ opacity: 1 }, 300);
				});

				linhaTempo.linhaTempoElementoInferior.animate({ height: heightElement }, 300, function () {
					linhaTempo.linhaTempoElementoInferiorLi.eq(linhaTempo.itemAtivo).animate({ opacity: 1 }, 300);
				});
			}, 400);
		};

		linhaTempo.init();

		linhaTempo.linhaTempoElementoLi.on('click', function () {
			var current = $(this);
			linhaTempo.setItemAtivo(current.index());
		});
	}());

	/*
	 * Função que mostra a listas dos estados que possuem OABs conveniadas com a Advise
	 */
	var resizeBox = {};
	(function () {
		resizeBox.heightBox = 0;
		resizeBox.Resize = function () {
			resizeBox.heightBox = $('.box-sobre-sistema .inicial').height() - $('.box-sobre-sistema span.titulo-grande').height();
			$('.lista-estados-ul-container').height(resizeBox.heightBox);
		};

		resizeBox.Resize();

		$(window).resize(function () {
			resizeBox.Resize();
		});

		$('.mostrar-lista-completa').on('click', function () {
			$('.lista-estados').addClass('enter-scale');
			setTimeout(function () {
				$('.lista-estados-ul-container').niceScroll({
					cursorcolor: '#969aa3',
					cursorwidth: '10px',
					cursorborder: 'none',
					railpadding: { top: 0, right: 20, left: 0, bottom: 0 }
				});
			}, 500);
		});

		$('.fechar-lista-completa').on('click', function () {
			$('.lista-estados').addClass('exit-scale');
			$('.lista-estados-ul-container').getNiceScroll().remove();
			setTimeout(function () {
				$('.lista-estados').removeClass('enter-scale exit-scale');
			}, 500);
		});
	}());
}(jQuery, window));